// CON-02 (subwoofer connection) — README.md.

import type { BuildContext } from '../context';
import type { Issue } from '../types';
import { productName, issueId } from '../copy';

export function checkCon02(ctx: BuildContext): Issue[] {
  if (!ctx.avUnit) return [];
  const subOuts = ctx.avUnit.specs.preouts.v.subOuts;
  const issues: Issue[] = [];

  for (const id of ctx.subIds) {
    const entry = ctx.doc.speakers.find((s) => s.id === id);
    const product = entry?.productId ? ctx.catalog.get(entry.productId) : undefined;
    if (!product || product.specs.kind !== 'subwoofer') continue; // not bound — not applicable

    const { lineLevel, highLevel } = product.specs.inputs.v;
    const pass = (subOuts > 0 && lineLevel) || (subOuts === 0 && highLevel);
    if (pass) continue;

    const wantsLineLevel = subOuts > 0;
    issues.push({
      id: issueId('CON-02', [id]),
      rule: 'CON-02',
      severity: 'error',
      text: `${productName(product)} can't connect to ${productName(ctx.avUnit.product)}.`,
      fix: `Choose a subwoofer with ${wantsLineLevel ? 'line-level' : 'speaker-level'} inputs.`,
      subjects: [id],
    });
  }
  return issues;
}
